import { map } from "rxjs/operators";

import { Align } from "src/app/core/enums/align.enum";
import { DataType } from "src/app/core/enums/datatype.enum";
import { Metadata } from "src/app/core/list/metadata/metadata.component";
import { LoteMetadata } from "../../lote/lote.metadata";
import { LoteInventarioDTO } from "../../lote/lote-inventario-dto.model";
import { StringUtil } from "src/app/core/framework/utils/string-util";
import { CategoriaProdutoService } from "src/app/farmacia/produto/categoria-produto/categoria-produto.service";
import { SortDirection } from "src/app/core/enums/sort-direction.enum";
import { ListHandlerService } from "src/app/core/list/list-handler.service";
import { ListaComponent } from "src/app/core/list/lista.component";
import { Lista } from "src/app/core/list/lista.model";


export class BaixaDeProdutoListaSelecaoMetadata {
  public static fieldIdVinculado = 'vinculado';

  public static getLocalHtml(local: 'E' | 'I', nomeInventario?: string): string {
    if ( local === 'I' ) {
      return `<label class='tag tag-purple' title='Setor ${nomeInventario || ''}'>S</label> ${nomeInventario ? StringUtil.abreviar(nomeInventario, 40) : ''}`;
    }
    else {
      return `<label class='tag tag-cyan' title='Estoque'>E</label>`;;
    }
  }

  static getMetadata(
            exibirUnidade: boolean,
            onToggleCheckbox: Function,
            onToggleCheckboxTodaPagina: Function,
            context: ListaComponent,
            modoDeVisualizacao: 'TODOS' | 'SELECIONADOS',
            onChangeQuantidade: Function
         ): Metadata[] {
    return [
      {
        fieldId: '',
        fieldName: 'Local',
        dataType: DataType.HTML,
        sortDirection: SortDirection.NONE,
        fnValorCelula: (data: LoteInventarioDTO) => {
          return this.getLocalHtml((data.idItemInventario ? 'I' : 'E'), data.nomeInventario);
        }
      }
      , {
        fieldId: 'nomeUnidade',
        fieldName: 'Unidade',
        hidden: !exibirUnidade,
        sortDirection: SortDirection.NONE,
      }
      // , {
      //   fieldId: 'tipoProduto',
      //   fieldName: 'Tipo',
      //   sortDirection: SortDirection.NONE,
      // }
      , {
        fieldId: 'categoriasProduto',
        fieldName: 'Categorias',
        fnValorCelula: (data: LoteInventarioDTO) => CategoriaProdutoService.parseCategoriasProdutoToHTML(data.categoriasProduto),
        dataType: DataType.HTML,
        sortDirection: SortDirection.NONE
      }
      , {
        fieldId: 'idProduto',
        fieldName: 'Id Produto',
        sortDirection: SortDirection.NONE,
      }
      , {
        fieldId: 'descricaoProduto',
        fieldName: 'Produto',
        sortDirection: SortDirection.NONE,
      }
      , {
        fieldId: 'descricaoLote',
        fieldName: 'Lote',
        sortDirection: SortDirection.NONE
      }
      , {
        fieldId: 'quantidade',
        fieldName: 'Quant.',
        dataType: DataType.NUMBER,
        align: Align.RIGHT,
        sortDirection: SortDirection.NONE,
        editable: (modoDeVisualizacao === 'SELECIONADOS'),
        fnClick: function(event: any, data: LoteInventarioDTO, rowIndex: number, lista: Lista, listHandlerService: ListHandlerService) {
          if (modoDeVisualizacao !== 'SELECIONADOS') {
            return;
          }

          const target = event.target || event.srcElement || event.currentTarget;
          const idAttr = target.attributes.id;
          const inputId = idAttr.nodeValue;
          const quantidadeMaximaPlaceholder = 'máx: ' + (data.quantidade);

          context.poi
                 .show(event, inputId, data.quantidade, quantidadeMaximaPlaceholder)
                 .pipe(
                    map(novaQuantidade => +novaQuantidade)
                  )
                 .subscribe(novaQuantidade => {
                    onChangeQuantidade(novaQuantidade,
                                       rowIndex,
                                       data);
                 });

        }
      }
      , {
          fieldId: 'dataVencimento',
          fieldName: 'Vencimento',
          align: Align.CENTER,
          dataType: DataType.HTML,
          sortDirection: SortDirection.NONE,
          fnValorCelula: (data: LoteInventarioDTO) => {
            if ( !data.dataVencimento ) {
              return '';
            }

            let cssClass = '';
            if ( new Date(data.dataVencimento) < new Date() ) {
              cssClass = 'danger';
            }
            return `<label class='${cssClass}'>
                      ${LoteMetadata.dateTimeUtil
                                    .dateToDiaMesAno(
                                      LoteMetadata.dateTimeUtil
                                                  .stringIsoToDate(
                                                    data.dataVencimento
                                                  )
                                    )}
                    </label>`;
          }
      }
      , {
        fieldId: BaixaDeProdutoListaSelecaoMetadata.fieldIdVinculado,
        fieldName: `<a class='clickable' title='Marcar/desmarcar todos desta página'>Todos</a>`,
        dataType: DataType.CHECKBOX,
        align: Align.CENTER,
        podeNaoExistir: true,
        sortDirection: SortDirection.NONE,
        fnClickTitulo: (event: any, resultset: any, rowIndex: number, lista: Lista, listHandlerService: ListHandlerService) => {
          onToggleCheckboxTodaPagina(event, resultset);
        },
        fnClick: (event: any, resultset: LoteInventarioDTO, rowIndex: number, lista: Lista, listHandlerService: ListHandlerService) => {
          onToggleCheckbox(event, resultset);
        },
      }
    ];
  }

}
